export const ossHost = 'https://3vj-fe.oss-cn-shenzhen.aliyuncs.com/project/material/img'
export const cardPopDelay = 500
export const cardPopDelayFirstHover = 1000
export const cardPopDelayHover = 180
